import axios from "axios";
import { getToken, getUserData, logout } from "actions";

const ApiQualidade = axios.create({
  baseURL: process.env.REACT_APP_API_QUALIDADE,
});

ApiQualidade.interceptors.request.use(
  (config) => {
    const token = getToken();
    const userData = getUserData();
    if (token) {
      config.headers.Authorization = token;
    }
    if (userData?.email) {
      config.headers["x-user-email"] = userData.email;
    }
    return config;
  }, (error) => {
    return Promise.reject(error);
  }
);

ApiQualidade.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.data?.error === "TokenExpiredError") {
      logout();
    }
    return Promise.reject(error);
  }
);


export default ApiQualidade;
